import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { apiUrl } from '../../config/api-url';
import { catchError, Observable } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { ErrorhandlerService } from './errorhandler.service';
import { AuthorizationService } from './authorization.service';
//import OidcConfig from '../../../assets/oidc-config.json';
import config from '../../../assets/config.json';
@Injectable({
  providedIn: 'root',
})
export class PersonalInfoService {
  private readonly apiUrl = environment.apiHost; // Use HTTPS and secure URLs
  private readonly endPoints = apiUrl;
  token: any = '';
  constructor(
    private _authservice: AuthorizationService,
    private _http: HttpClient,
    private _errorHandlerService: ErrorhandlerService,
  ) {
    this._authservice.getAccessToken().then((token) => {
      this.token = token;
    });
  }

  private GetHttpHeaderOptions() {
    const httpHeaderOptions = {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + this.token,
        'Ocp-Apim-Subscription-Key': config.Ocp_Apim_Subscription_Key,
      }),
    };
    return httpHeaderOptions;
  }

  PersonalInfo(body: any): Observable<any> {
    const httpHeaderOptions: { headers: HttpHeaders } = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + this.token,
        'Ocp-Apim-Subscription-Key': config.Ocp_Apim_Subscription_Key,
      }),
    };
    return this._http
      .post(this.apiUrl + this.endPoints.personalInformationComponent, body, httpHeaderOptions)
      .pipe(catchError((error: HttpErrorResponse) => this._errorHandlerService.handleError(error)));
  }

  ValidatePin(body: any): Observable<any> {
    const httpHeaderOptions = this.GetHttpHeaderOptions();
    return this._http
      .post(this.apiUrl + this.endPoints.validatePin, body, httpHeaderOptions)
      .pipe(catchError((error: HttpErrorResponse) => this._errorHandlerService.handleError(error)));
  }

  ValidateSecurityAnswer(body: any): Observable<any> {
    const httpHeaderOptions = this.GetHttpHeaderOptions();
    return this._http
      .post(this.apiUrl + this.endPoints.validateSecurityAnswer, body, httpHeaderOptions)
      .pipe(catchError((error: HttpErrorResponse) => this._errorHandlerService.handleError(error)));
  }
}
